import React from "react";
import { Box, Typography, Divider, Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  section: {
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    color: theme.palette.primary.main,
  },
  row: {
    display: "flex",
    alignItems: "flex-start",
    padding: theme.spacing(0.75, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  label: {
    minWidth: 180,
    maxWidth: 220,
    flexShrink: 0,
    color: theme.palette.text.secondary,
    fontWeight: 500,
    paddingRight: theme.spacing(2),
  },
  value: {
    flex: 1,
    color: theme.palette.text.primary,
    wordBreak: "break-word",
  },
  empty: {
    color: theme.palette.text.disabled,
    fontStyle: "italic",
  },
});

/**
 * Renders enrollment payload fields as labeled rows — never raw JSON.
 */
function KeyValueSection({ classes, title, rows = [], emptyMessage = "No data available" }) {
  const visible = (rows || []).filter(
    (r) => r && r.value !== undefined && r.value !== null
  );

  return (
    <Box className={classes.section}>
      {title ? (
        <>
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>
          <Divider />
        </>
      ) : null}
      {!visible.length ? (
        <Typography className={classes.empty} variant="body2">
          {emptyMessage}
        </Typography>
      ) : (
        <Box mt={1}>
          {visible.map((row) => (
            <div className={classes.row} key={`${row.label}-${row.value}`}>
              <Typography variant="body2" className={classes.label}>
                {row.label}
              </Typography>
              <Typography variant="body2" className={classes.value}>
                {row.value}
              </Typography>
            </div>
          ))}
        </Box>
      )}
    </Box>
  );
}

export function KeyValueGrid({ classes, title, rows = [], columns = 2 }) {
  const visible = (rows || []).filter(
    (r) => r && r.value !== undefined && r.value !== null
  );
  return (
    <Box className={classes.section}>
      {title ? (
        <Typography variant="h6" className={classes.title}>
          {title}
        </Typography>
      ) : null}
      <Grid container spacing={1}>
        {visible.map((row) => (
          <Grid item xs={12} sm={12 / columns} key={`${row.label}-${row.value}`}>
            <div className={classes.row}>
              <Typography variant="body2" className={classes.label}>
                {row.label}
              </Typography>
              <Typography variant="body2" className={classes.value}>
                {row.value}
              </Typography>
            </div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default withStyles(styles)(KeyValueSection);
